import { ReactNode } from "react";
import Icon, { IconsVariant } from "../Icon/Icon";

interface Props {
  icon: IconsVariant;
  title: string;
  description?: string;
  action?: ReactNode;
  children: ReactNode;
}

const ProductFormSection = ({
  icon,
  title,
  description,
  action,
  children,
}: Props) => (
  <section className="rounded-2xl border border-border bg-white p-8">
    <div className="mb-8 flex items-start gap-4">
      <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-xl bg-light">
        <Icon className="h-7 w-7 fill-primary" variants={icon} />
      </div>
      <div className="min-w-0 flex-1">
        <h2 className="m-0 text-[1.7rem] font-semibold leading-tight">
          {title}
        </h2>
        {description && (
          <p className="mt-1 mb-0 text-small text-text-secondary">
            {description}
          </p>
        )}
      </div>
      {action}
    </div>
    {children}
  </section>
);

export default ProductFormSection;
